import { graphql } from '../../../graphql/generated';

export const CREATE_PROFILE_MUTATION = graphql(`
  mutation CreateProfile($input: ProfileInput!) {
    createProfile(input: $input) {
      id
    }
  }
`);
